import { PAYMENT_BEHAVIOR } from "@/helpers/order/payment/behavior";
import { makePaymentResult } from "../paymentResult";

/**
 * NABancard integration processor.
 *
 * Consumes the result of the checkout's `NABancardPaymentProcessing` device
 * call, which has the shape:
 *   { response, NABancardResponseObject, requestBody, error }
 * where `response` is the raw XML string (empty/missing on failure) and
 * `NABancardResponseObject` carries parsed fields (tips, response_code, ...).
 *
 * Behavior parity with the legacy `pay()` branch:
 *   - approved when a non-empty `response` string is present;
 *   - tip override only when the response is present AND a truthy tip exists;
 *   - processor_response is the raw XML string.
 */
export const nabancardProcessor = {
  behaviors: [PAYMENT_BEHAVIOR.NABANCARD_INTEGRATION],

  normalize(deviceResult = {}) {
    const response = deviceResult.response;
    const obj = deviceResult.NABancardResponseObject || {};
    const approved = !!response;

    return makePaymentResult({
      approved,
      processorResponse: response,
      tips: approved && obj.tips ? obj.tips : null,
      // Preserve the legacy value exactly: NABancard never sets card_lastfour, so
      // the persisted payment historically carried `undefined` (key omitted on
      // JSON serialization). Keep undefined rather than coercing to null.
      cardLastFour: obj.card_lastfour,
      error: deviceResult.error != null ? deviceResult.error : null,
      raw: deviceResult,
    });
  },
};
